import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Stack,
  Image,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useState } from "react";

const CreateEvent = () => {
  const access = localStorage.getItem("token");
  const [eventName, seteventName] = useState("");
  const [eventType, seteventType] = useState("");
  const [venue, setvenue] = useState("");
  const [eventDetails, seteventDetails] = useState("");
  const [eventTiming, seteventTiming] = useState("");
  const [expectedNoOfGuests, setexpectedNoOfGuests] = useState("");
  const [venuePinCode, setvenuePinCode] = useState("");
  const [upiId, setupiId] = useState("");
  const [reqMessage, setreqMessage] = useState("");

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("eventName", eventName);
    formData.append("eventType", eventType);
    formData.append("venue", venue);
    formData.append("eventDetails", eventDetails);
    formData.append("eventTiming", new Date(eventTiming).toISOString());
    formData.append("expectedNoOfGuests", expectedNoOfGuests);
    formData.append("venuePinCode", venuePinCode);
    formData.append("upiId", upiId);
    formData.append("reqMessage", reqMessage);
    axios
      .post("https://dev.api.wishfy.io/events/event/create", formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      })
      .then((response) => {})
      .catch((error) => {
        // alert.error(`${error.message}`);
        console.error(error);
      });
  };

  return (
    <Stack minH={"100vh"} direction={{ base: "column", md: "row" }}>
      <Flex p={8} flex={1} align={"center"} justify={"center"}>
        <Stack spacing={1} w={"full"} maxW={"md"}>
          <Heading fontSize={"2xl"}>Create An Event!</Heading>
          <FormControl id="eventName">
            <FormLabel>Event Name</FormLabel>
            <Input
              type="text"
              value={eventName}
              onChange={(e) => seteventName(e.target.value)}
            />
          </FormControl>
          <FormControl id="eventType">
            <FormLabel>Event Type</FormLabel>
            <Input
              type="text"
              value={eventType}
              onChange={(e) => seteventType(e.target.value)}
            />
          </FormControl>
          <FormControl id="venue">
            <FormLabel>Venue</FormLabel>
            <Input
              type="text"
              value={venue}
              onChange={(e) => setvenue(e.target.value)}
            />
          </FormControl>
          <FormControl id="eventDetails">
            <FormLabel>Event Details</FormLabel>
            <Input
              type="text"
              value={eventDetails}
              onChange={(e) => seteventDetails(e.target.value)}
            />
          </FormControl>
          <FormControl id="eventTiming">
            <FormLabel>Event Timing</FormLabel>
            <Input
              type="datetime-local"
              value={eventTiming}
              onChange={(e) => seteventTiming(e.target.value)}
            />
          </FormControl>
          <FormControl id="expectedNoOfGuests">
            <FormLabel>Expected No. Of Guests</FormLabel>
            <Input
              type="text"
              value={expectedNoOfGuests}
              onChange={(e) => setexpectedNoOfGuests(e.target.value)}
            />
          </FormControl>
          <FormControl id="venuePinCode">
            <FormLabel>Venue Pin Code</FormLabel>
            <Input
              type="text"
              value={venuePinCode}
              onChange={(e) => setvenuePinCode(e.target.value)}
            />
          </FormControl>
          <FormControl id="upiId">
            <FormLabel>Upi ID</FormLabel>
            <Input
              type="text"
              value={upiId}
              onChange={(e) => setupiId(e.target.value)}
            />
          </FormControl>
          <FormControl id="reqMessage">
            <FormLabel>Req Message</FormLabel>
            <Input
              type="text"
              value={reqMessage}
              onChange={(e) => setreqMessage(e.target.value)}
            />
          </FormControl>
          <Stack spacing={6}>
            <Button
              onClick={handleSubmit}
              colorScheme={"blue"}
              variant={"solid"}
            >
              Create Event
            </Button>
          </Stack>
        </Stack>
      </Flex>
      <Flex flex={1}>
        <Image
          alt={"Login Image"}
          objectFit={"cover"}
          src={
            "https://png.pngitem.com/pimgs/s/192-1926777_upcoming-events-png-transparent-png.png"
          }
        />
      </Flex>
    </Stack>
  );
};

export default CreateEvent;
